import { api } from 'common';

export function getSubFlowBlockDefaultConfig(): api.FlowDefinition.SubFlowV1BlockConfig {
  return {
    flowDefinitionId: '',
    flowId: '',
    startDataBlockName: '',
    versionTarget: api.FlowDefinition.FlowVersionTarget.Published,
  };
}
